module.exports = __webpack_public_path__ + "img/betting_box.dd818bc.png";